import React from "react";

import CustomSelect from "../../../../../components/elements/CustomSelect";
import EditableField from "../../../../../components/elements/EditableField";

import {
    WORKSPACE_TYPES,
    WORKSPACE_TEMPLATES
} from "../../../../../utils/workspaceTemplates";

import {LANGUAGES} from "../../../../../utils/constants";

export default function ProjectSettings({
                                            project,
                                            updateAtPath
                                        }) {

    const workspace = project.workspace;

    const templates =
        WORKSPACE_TEMPLATES[workspace.type] || [];

    return (

        <div className="bg-white border rounded-md p-10 flex flex-col gap-8">

            <h2>Project Settings</h2>

            <CustomSelect
                title="Workspace"
                value={workspace.type}
                options={WORKSPACE_TYPES}
                onChange={(e) => {

                    const type = e.target.value;

                    const firstTemplate =
                        (WORKSPACE_TEMPLATES[type] || [])[0];

                    updateAtPath(
                        ["workspace"],
                        {
                            type,
                            template: firstTemplate ? firstTemplate.value : ""
                        }
                    );

                }}
            />

            <CustomSelect
                title="Template"
                value={workspace.template}
                options={templates}
                onChange={(e) => {

                    updateAtPath(
                        ["workspace", "template"],
                        e.target.value
                    );

                }}
            />

            <CustomSelect
                title="Language"
                value={workspace.language}
                options={LANGUAGES}
                onChange={(e) => {

                    updateAtPath(
                        ["workspace", "language"],
                        e.target.value
                    );

                }}
            />

            <EditableField
                title="Energy Cost"
                type="number"
                value={project.meta.energyCost}
                onSave={(value) => {

                    updateAtPath(
                        ["meta", "energyCost"],
                        Number(value)
                    );

                }}
            />

        </div>

    );

}